import React from "react";

const NetworkSignal = React.forwardRef((props, ref) => {
  const { signal = 1 } = props;

  const getFill = (n) => {
    if (n <= signal) {
      return "#004057";
    } else {
      return "#e1f5fc";
    }
  };

  return (
    <svg
      {...props}
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
      width="24px"
      height="24px"
      className="wizard-status-child"
    >
      <path
        fill={getFill(1)}
        d="M96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
      ></path>
      <path
        fill={getFill(2)}
        d="M192 288c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96"
      ></path>
      <path
        fill={getFill(3)}
        d="M320 192c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"
      ></path>
      <path
        fill={getFill(4)}
        d="M448 96c17.7 0 32 14.3 32 32v352c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32z"
      ></path>
      <path
        fill={getFill(5)}
        d="M576 0c17.7 0 32 14.3 32 32v448c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32z"
      ></path>
    </svg>
  );
});

export default NetworkSignal;
